module.exports = __webpack_public_path__ + "img/huntress_small.f2344bae.png";